export const uiConstants = {
  notification: {
    info: 'Info',
    error: 'Error',
    warning: 'Warning',
    success: 'Success'
  },
  pages: ['play', 'sidecar', 'score', 'leaderBoard']
}
